import React, { JSX, ReactNode } from "react";
import { Tabs } from "antd";

import styled from "styled-components";
import color from "../../resource/color";

interface Props {
  data: {
    key: string;
    label: string | ReactNode;
    children?: JSX.Element;
    disabled?: boolean;
  }[];
  defaultTab?: string;
  onChange?: (v: string) => void;
}

export const PrimaryTabsContainer = styled.div`
  font-family: "IBM Plex Sans Thai", "Helvetica";
  .ant-tabs-tab-btn {
    font-family: "IBM Plex Sans Thai", "Helvetica";
  }
  margin-top: 24px;
  .ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
    padding: 8px 16px;
  }
  .tabs {
    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 16px !important;
    }
    .ant-tabs-tab-btn {
      font-size: 14px;
      color: ${color.Text1};
      font-weight: 400;
      font-family: "IBM Plex Sans Thai", "Helvetica";
      :hover {
        color: ${color.primary} !important;
      }
      :focus {
        font-weight: 700;
        color: ${color.Text2} !important;
      }
      :active {
        font-weight: 700;
        color: ${color.Text2} !important;
      }
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${color.primary} !important;

      font-size: 14px;
      font-weight: 700;
      font-family: "IBM Plex Sans Thai", "Helvetica";
    }
    .ant-tabs-tab.ant-tabs-tab-active {
      z-index: 2;
      border-bottom: 2px solid ${color.primary} !important;
    }
    .ant-tabs-ink-bar {
      background: ${color.primary} !important;
      height: 2px;
    }
  }
`;

const TabsContainer = styled.div`
  margin-top: 24px;
  .ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
    padding: 8px 16px;
  }
  .tabs {
    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 16px !important;
    }
    .ant-tabs-tab-btn {
      font-size: 14px;
      color: ${color.Text1};
      font-weight: 400;
      font-family: "IBM Plex Sans Thai", "Helvetica";
      :hover {
        color: ${color.primary} !important;
      }
      :focus {
        font-weight: 700;
        color: ${color.Text2} !important;
      }
      :active {
        font-weight: 700;
        color: ${color.Text2} !important;
      }
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${color.Text2} !important;

      font-size: 14px;
      font-weight: 700;
      font-family: "IBM Plex Sans Thai", "Helvetica";
    }
    .ant-tabs-ink-bar {
      background: ${color.primary};
      height: 2px;
    }
  }
`;
function AntdTabs({ data = [], defaultTab, onChange }: Props): JSX.Element {
  return (
    <TabsContainer>
      <Tabs activeKey={defaultTab} items={data} className='tabs' size='large' onChange={onChange} />
    </TabsContainer>
  );
}

export default AntdTabs;
